import React from "react";
import * as THREE from "three";

// World Financial Center (Brookfield Place) + Battery Park City stitching, west toward Hudson.
export default function WorldFinancialCenter() {
  const glass = "#8fb2c9";
  const towers = [
    { x: -300, z: 40, w: 46, d: 46, h: 180, top: "pyramid" },
    { x: -340, z: 150, w: 42, d: 42, h: 150, top: "dome" },
    { x: -300, z: -90, w: 40, d: 40, h: 160, top: "step" },
    { x: -360, z: -190, w: 38, d: 38, h: 130, top: "flat" },
  ];
  return (
    <group>
      {towers.map((t, i) => (
        <group key={i} position={[t.x, 0, t.z]}>
          <mesh position={[0, t.h / 2, 0]} castShadow receiveShadow>
            <boxGeometry args={[t.w, t.h, t.d]} />
            <meshStandardMaterial color={glass} metalness={0.35} roughness={0.35} />
          </mesh>
          {t.top === "pyramid" && (
            <mesh position={[0, t.h + 12, 0]} castShadow>
              <coneGeometry args={[t.w * 0.72, 26, 4]} />
              <meshStandardMaterial color="#7a8f5a" metalness={0.3} roughness={0.5} />
            </mesh>
          )}
          {t.top === "dome" && (
            <mesh position={[0, t.h + 6, 0]} castShadow>
              <sphereGeometry args={[t.w * 0.6, 20, 12, 0, Math.PI * 2, 0, Math.PI / 2]} />
              <meshStandardMaterial color="#9fb0bd" metalness={0.4} roughness={0.4} />
            </mesh>
          )}
          {t.top === "step" && (
            <mesh position={[0, t.h + 6, 0]} castShadow>
              <boxGeometry args={[t.w * 0.7, 12, t.d * 0.7]} />
              <meshStandardMaterial color={glass} metalness={0.35} roughness={0.35} />
            </mesh>
          )}
        </group>
      ))}
      {/* Winter Garden barrel-vault glass atrium */}
      <mesh position={[-320, 22, 0]} rotation={[0, 0, Math.PI / 2]}>
        <cylinderGeometry args={[24, 24, 70, 20, 1, true, 0, Math.PI]} />
        <meshStandardMaterial color="#cfe0ec" metalness={0.3} roughness={0.15} transparent opacity={0.55} side={THREE.DoubleSide} />
      </mesh>
      {/* Battery Park City residential blocks (SW) */}
      {[
        [-470, 320, 44, 90],
        [-520, 230, 40, 80],
        [-470, 460, 42, 70],
        [-540, 60, 46, 100],
        [-500, -80, 40, 85],
      ].map((b, i) => (
        <mesh key={`bpc${i}`} position={[b[0], b[3] / 2, b[1]]} castShadow receiveShadow>
          <boxGeometry args={[b[2], b[3], b[2]]} />
          <meshStandardMaterial color="#b08d6a" metalness={0.05} roughness={0.85} />
        </mesh>
      ))}
      {/* esplanade / green strip along Hudson */}
      <mesh rotation={[-Math.PI / 2, 0, 0]} position={[-400, 0.06, 80]} receiveShadow>
        <planeGeometry args={[70, 700]} />
        <meshStandardMaterial color="#5e7f4a" roughness={0.95} />
      </mesh>
    </group>
  );
}
